import { render, staticRenderFns } from "./UserMatchList.vue?vue&type=template&id=3b370d23&"
import script from "./UserMatchList.vue?vue&type=script&lang=js&"
export * from "./UserMatchList.vue?vue&type=script&lang=js&"
import style0 from "./UserMatchList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports